<template>
	<div class="compare-fractions-component">
		<div class="compare-fractions-container">
			<template v-if="isFractionAndWhole">
				<div class="compare-fraction-with-whole-number">
					<p>To compare a fraction with a whole number,
						<span v-if="isMin">the fraction(<component :is="fractionAnswer" />) is always lower than a whole number({{ wholeOthers }})</span>
						<span v-else>the whole number({{ wholeAnswer }}) is always greater than a fraction(<component :is="otherFraction" />) </span></p>
				</div>
			</template>
			<template v-else-if="isMixedAndWhole">
				<div class="compare-mixed-with-whole-number">
					<p>To compare a whole number with a mixed number, we firstly compare whole part of mixed with whole number.</p>
					<template v-if="isSameWholeNumber">
						<p>Since the whole numbers are equals, <span v-if="isMin">the whole number ({{ wholeAnswer }}) automatically becomes lesser than a mixed number(<component :is="otherMixed" />)</span><span v-else>the mixed number(<component :is="mixedAnswer" />) becomes automatically greater than a whole number({{ wholeOthers }})</span></p>
					</template>
					<template v-else>
						<p>We see that, {{ wholeAnswer }} is <span v-html="rangeTh"></span> {{ wholeOthers }}. So, <component :is="mixedAnswer" /> automatically becomme <span v-html="rangeTh"></span> <component :is="otherMixed" /></p>
					</template>
				</div>
			</template>
			<template v-else-if="isPartMixed">
				<div class="fraction-and-mixed">
					<p>In this case, we have one mixed number(whole number with a fraction) and one fraction. So, automatically {{ this.isMin ? 'fraction becomes lesser than mixed number' : 'mixed number becomes greater than fraction' }}. Means that <component :is="mixedAnswer" /> is <span v-html="rangeTh"></span> <component :is="otherMixed" /></p>
				</div>
			</template>
			<template v-else-if="isCompleteMixed">
				<div class="complete-mixed">
				<p>In this case, We’ll first of all compare the whole numbers before the fractions:</p>
					<template v-if="isSameWholeNumber">
						<p>Since the whole numbers are equal, we have to compare the fractions</p>
						<compare-fractions :operator="operator" :terms="fractionsMixed" />
					</template>
					<template v-else><p>You see that, the whole number {{ wholeAnswer }} is <span v-html="rangeTh"></span> {{ wholeOthers }}. So, <component :is="mixedAnswer" /> automatically becomes <span v-html="rangeTh"></span> <component :is="otherMixed" /></p></template>
				</div>
			</template>
			<template v-else>
				<div class="unlike-denominator" v-if="!isSameDenominator">
					<div class="note-compare-fractions">
						<p>To solve this, we need to find the equivalent fractions with the same denominators and compare the numerators by following the steps below</p>
						<ol class="compare-fractions-steps steps">
							<li class="step">
								<div class="lbl-step">Multiply the first fraction (numerator and denominator) by the denominator of the second fraction. <br><span class="ml-4">Do it with all fractions</span></div>
								<ReduceToSameDenominator :terms="terms" />
							</li>
							<li class="step">
								<div class="lbl-step">Finally compare the numerators of the two fractions: <span class="text-info">the bigger the numerator is, the greater the fraction</span>.</div>
								<div class="sorted-numerators" v-html="fractions_sorted.join(isEqual ? '=' : isMin ? '>' : '<')"></div>
							</li>
						</ol>
					</div>
				</div>
				<div v-else class="like-denominators">
					<p class="lbl-compare-numerators">To solve this, we we just compare the numerators of fractions since the denominators are the same. <br>You know that, <span class="text-info">the bigger the numerator is, the greater the fraction</span>.</p>
					<div class="sorted-numerators" v-html="fractions_sorted.join(isEqual ? '=' : isMin ? '>' : '<')"></div>
				</div>
				<div class="conclusion">
					<component :is="comparaisonLabel" />
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	const $vars = require("../scripts/variables");
	const $operations = $vars.operations;

	import FractionComponent from '../FractionComponent.vue';
	import ReduceToSameDenominator from './OperationReduceFractionsSameDenominator.vue';
	import Fraction from '../scripts/Fraction';
	import UFCT from 'usefull-functions';
	const $functions = require('../scripts/functions');

	export default{
		name: "compare-fractions",
		components: { FractionComponent, ReduceToSameDenominator },
		props: {
			operator: { type:String, required: false, default: 'min'},
			terms: { type: [Array], required: true},
		},
		data(){
			return{
				isMin: $vars.operators.checkOp_unknow('min', this.operator)/* this.operator == 'min'*/,
				result: {},
				original_result: {},
				fractionsData: this.terms.map(term => new Fraction(term))
			};
		},
		computed:{
			fractions_sorted(){
				let reduced = $operations.rsd_fractions(this.terms).map(el => el.num), sorted = this.isMin ? reduced.sort_gt() : reduced.sort_lt();
				return sorted.map((el, i) => $functions.tag('span', el, { class: 'mx-2 ' + (i == sorted.length - 1 ? 'result' : '')}));
			},
			range(){
				return $functions.tag('strong', this.isMin ? 'lowest' : 'greatest');
			},
			rangeTh() {
				return $functions.tag('strong', this.isMin ? 'lesser than' : 'greater than');
			},
			isSameDenominator() {
				return this.fractionsData.every( (val, i, arr) => val.den === arr[0].den );
			},
			sameDenominators() {
				return $operations.rsd_fractions(this.terms);
			},
			comparaisonLabel() {
				let numerators = $operations.rsd_fractions(this.terms).map(el => el.num).sort_lt(), sameDenominators = $operations.rsd_fractions(this.terms), text = '',
					answer = sameDenominators.filter(el => this.result.equal_to(el)).pop(),
					others = sameDenominators.filter(el => !this.result.equal_to(el)).map((fraction, i) => {
						let reduced = (new Fraction(fraction)).toString(),
							original = this.terms.map( term => new Fraction(term)).filter(term => term.equal_to(fraction)).pop();
						return `${reduced}(${original})`;
					});
				if (numerators.every((val, i, arr) => val === arr[0] )) {
					let terms = this.terms_str(this.sameDenominators.map((fract, i) => {
						let f = this.fractionsData[i], o = UFCT.tag('fraction-component', '', {':fraction': `{num: ${f.num}, den: ${f.den}}`}),
							s = UFCT.tag('fraction-component', '', {':fraction': `{num: ${fract.num}, den: ${fract.den}}`}), 
							r = `${s}(${o})`;
							// log('forming terms on i:', i, 'fract:', fract, 'original:', f, 'str:', o, 's:', s, 'returned:', r);
						return r;
					}));
					text = `Since the numerators are all equals it implies that fractions ${terms} are equals`;
				} else if (this.isMin) {
					text = `Since ${numerators[0]} is the lowest of the numerators, it implies that ${answer}(${this.original_result}) is less than ${others}`;
				} else {
					text = `Since ${numerators.getLast()} is the greatest of the numerators, it implies that ${answer} is greater than ${others}`;
				}
				return {
					template: UFCT.tag('div', text, { class: 'note-conclusion' }),
					components: {FractionComponent},
					data() { return {} }
				}
			},
			isEqual() {
				let numerators = $operations.rsd_fractions(this.terms).map(el => el.num).sort_lt();
				return numerators.every((val, i, arr) => val === arr[0]);
			},
			mixedAnswer() {
				return {
					template: UFCT.tag('span', this.original_result.intFractionNotation, {class: 'mixed-answer'}),
					components: { FractionComponent },
					data() {
						return {}
					}
				}
			},
			isPartMixed() {
				return this.fractionsData.map(fraction => fraction.intVal >= 1).reduce((a, b) => a || b, false) && !this.isCompleteMixed;
			},
			isCompleteMixed() {
				return this.fractionsData.map(fraction => fraction.intVal >= 1).reduce((a, b) => a && b, true);
			},
			isMixedAndWhole() {
				return this.fractionsData.map(fraction => fraction.intVal == fraction.num / fraction.den).reduce((a, b) => a || b, false) && this.isPartMixed;
			},
			isFractionAndWhole() {
				return this.fractionsData.every((fraction) => fraction.num < fraction.den || fraction.intVal == fraction.num / fraction.den) && this.fractionsData.map(fraction => fraction.intVal == fraction.num / fraction.den).reduce((a, b) => a || b, false) && !this.isCompleteMixed && !this.isPartMixed;
			},
			wholeAnswer() {
				return this.original_result.intVal;
			},
			wholeOthers() {
				return this.fractionsData.filter(term => !term.equal_to(this.result)).map(term => term.intVal).join(', ');
			},
			otherMixed() {
				let others = this.fractionsData.filter(term => !term.equal_to(this.result)).map(term => term.intFractionNotation);
				return {
					template: UFCT.tag('span', others.join(', '), { class: 'other-mixed-fractions' }),
					components: { FractionComponent },
					data() {
						return {}
					}
				}
			},
			fractionsMixed() {
				return this.fractionsData.map(term => term.fractionOfMixed);
			},
			isSameWholeNumber() {
				return this.fractionsData.map(term => term.intVal).every((a, i, arr) => a == arr[0]);
			},
			otherFraction() {
				return {
					template: UFCT.tag('span', this.fractionsData.filter(term => !term.equal_to(this.result)).join(', '), {class: 'other-fraction'}),
					components: { FractionComponent }
				};
			},
			fractionAnswer() {
				return {
					template: UFCT.tag('span', this.original_result, {class: 'result-fraction'}),
					components: { FractionComponent },
					name: 'ResultFraction'
				}
			}
		},
		created(){
			this.result = $operations.unknow(this.operator, this.terms);
			this.original_result = new Fraction(this.terms.filter(el => this.result.equal_to(el)).pop());
		},
		methods: {
			terms_string(fractionsArray) {
				if (fractionsArray.length == 1) {
					return fractionsArray.map(fraction => new Fraction(fraction)).slice(0, -1).map(fraction => fraction.toString()).join(', ');
				}
				let last = this.fractionsData.getLast().toString();
				return fractionsArray.map(fraction => new Fraction(fraction)).slice(0, -1).map(fraction => fraction.toString()).join(', ') + ` and ${last}`
			},
			terms_str(strs) {
				if (strs.length == 1) {
					return strs.join(', ');
				}
				let last = strs.getLast();
				return strs.slice(0, -1).join(', ') + ` and ${last}`;
			}
		}
	};
</script>

<style lang="scss">
	.compare-fractions-component {
		font-size: 0.8em;
		.compare-fractions-container {
			.unlike-denominator {
				.note-compare-fractions {}
			}
			.like-denominator {}
		}
	}
</style>